import { ApiError } from '../api/client';

export default function ErrorBanner({ error }: { error: unknown }) {
  if (!error) {
    return null;
  }

  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'Something went wrong.';

  return (
    <div className="banner banner--error" role="alert">
      <strong>Problem:</strong> {message}
    </div>
  );
}
